<template>
  <div class="consecutive-widget-edit-wrap relative">
    <menu-item label="活动">
      <activity-select v-model="model.bizId" :chain-id.sync="model.chainId" :type="7" />
    </menu-item>
    <!-- 背景图片 -->
    <menu-item :label="$t('head.backImg')">
      <menu-fill :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="PC端背景图">
      <menu-background-image :target="model.background" target-key="background" />
    </menu-item>
    <menu-item label="移动端背景图">
      <menu-background-image :target="model.mobileBackground" target-key="background" />
    </menu-item>
    <!-- 布局 -->
    <menu-item :border-bottom="true" class="menu-item-switch pt-4 pb-3" :label="$t('menu.layout')">
      <menu-switch v-model="model.titleVisible" label="标题" target-key="titleVisible" />
      <menu-background-image v-if="model.titleVisible" :target="model.helpIcon" target-key="helpIcon" image-size-key=" "
        image-opacity-key=" " class="!mb-0" label="提示按钮" />
      <div v-if="model?.helpIcon?.backgroundImageShow" class="bg-fillColor-2 p-2 mb-2">
        <nav-edit :target="model.nav" :site="site" />
      </div>
      <menu-switch v-model="model.subtitleVisible" class="mt-2" label="描述" target-key="subtitleVisible" />
      <menu-switch v-model="model.detailVisible" class="mt-2" label="展示道具详情" target-key="detailVisible" />
    </menu-item>
    <menu-item label="卡片圆角">
      <menu-slider v-model="model.cardRadius" target-key="cardRadius" />
    </menu-item>
    <menu-item label="卡片阴影">
      <menu-slider v-model="model.cardShadow" :max="50" target-key="cardShadow" />
    </menu-item>
    <menu-item label="卡片布局">
      <im-select v-model="model.layout" class="w-full" size="small" :options="cardLayoutOptions" />
    </menu-item>
    <menu-item v-if="AccumulationLayoutEnum.Col === model.layout && $store.getters.isMobile" label="移动端卡片尺寸">
      <im-select v-model="model.cardSizeType" class="w-full" size="small" target-key="cardSizeType"
        :options="cardSizeOptions" />
    </menu-item>
    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>
    <menu-item label="倒计时文字色">
      <menu-fill :target="model.countdownTextColor" solid-color target-key="countdownTextColor" />
    </menu-item>
    <menu-item label="倒计时背景色">
      <menu-fill :target="model.countdownBackgroundColor" target-key="countdownBackgroundColor" />
    </menu-item>
    <!-- <menu-item label="按钮文字颜色">
      <menu-fill :target="model.buttonTextColor" solid-color target-key="buttonTextColor" />
    </menu-item> -->
    <menu-item label="奖品卡片背景">
      <menu-fill :target="model.cardBackground" target-key="cardBackground" />
      <menu-background-image class="mt-2" :target="model.cardBackground" target-key="cardBackground" />
    </menu-item>
    <menu-item label="奖品LOGO背景">
      <menu-fill :target="model.logoBackground" target-key="logoBackground" />
      <menu-background-image class="mt-2" :target="model.logoBackground" target-key="logoBackground" />
    </menu-item>
    <menu-item label="领取按钮">
      <menu-fill :target="model.getBackground" target-key="getBackground" />
      <menu-background-image class="mt-2" :target="model.getBackground" target-key="getBackground" />
    </menu-item>
    <menu-item label="领取按钮文字色">
      <menu-fill :target="model.getButtonTextColor" solid-color target-key="getButtonTextColor" />
    </menu-item>
    <menu-item label="不可领取按钮">
      <menu-fill :target="model.disabledBackground" target-key="disabledBackground" />
      <menu-background-image class="mt-2" :target="model.disabledBackground" target-key="disabledBackground" />
    </menu-item>
    <menu-item label="不可领取按钮文字色">
      <menu-fill :target="model.disabledTextColor" solid-color target-key="disabledTextColor" />
    </menu-item>
    <menu-item label="进度条背景">
      <menu-fill :target="model.progressBackground" target-key="progressBackground" />
      <menu-background-image class="mt-2" :target="model.progressBackground" target-key="progressBackground" />
    </menu-item>
    <menu-item label="进度条填充">
      <menu-fill :target="model.innerBackground" target-key="innerBackground" />
      <menu-background-image class="mt-2" :target="model.innerBackground" target-key="innerBackground" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import MenuItem from "~/components/menu/menuItem";
import MenuSwitch from "~/components/menu/menuSwitch";
import MenuFill from "~/components/menu/menuFill";
import ImSelect from "~/components/common/ImSelect";
import MenuSlider from "~/components/menu/menuSlider";
import navEdit from "~/site/components/navEdit.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage";
import { insertStep } from "~/utils/event";
import ActivitySelect from '~/site/components/activitySelect/index.vue'
import { AccumulationLayoutEnum, AccumulationColLayoutSizeEnum } from '~/enums/data'



export default {
  name: "ConsecutiveWidgetEdit",
  components: {
    ActivitySelect,
    MenuItem,
    MenuSwitch,
    MenuFill,
    ImSelect,
    MenuBackgroundImage,
    MenuSlider,
    navEdit
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    site: Object
  },
  data() {
    return {
      AccumulationLayoutEnum,
      menuList: [],
      typeOptions: [
      ],
      cardSizeOptions: [
        {
          label: '大尺寸3个',
          value: AccumulationColLayoutSizeEnum.Three
        },
        {
          label: '小尺寸4个',
          value: AccumulationColLayoutSizeEnum.Four
        }
      ],
      cardLayoutOptions: [
        {
          label: '一行展示',
          value: AccumulationLayoutEnum.Row
        },
        {
          label: '全部展示',
          value: AccumulationLayoutEnum.Col
        }
      ]
    }
  },

  methods: {
    switchChange(value, item) {
      const layout = cloneDeep(this.model.layout)
      insertStep(this, ['layout'], layout)
      item.value = value
    }
  }
}
</script>

<style lang='less' scoped></style>
<style lang="less">
.activity-rich-text {
  position: relative;
  margin-bottom: 16px;

  .ql-editor.ql-blank::before {
    color: rgba(255, 255, 255, 0.3);
    font-style: normal;
  }

  .ql-bubble {
    .ql-tooltip {
      position: absolute;
      top: 38px !important;
      left: 0 !important;
      background: #151724 !important;
      border: 0.5px solid rgba(255, 255, 255, 0.3);
      z-index: 2021;
    }
  }

  .rich-text {
    border-radius: 2px;

    &:hover {
      box-shadow: none;
    }
  }
}
</style>
